import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSortedSelectionsIds } from '~SpectateStore/hooks/selectionsHooks';
import SeeMore from '~shared/ui/SeeMore';
import CellSelectionLine from './CellSelectionLine';
import './styles/gridColumns.scss';

const DEFAULT_EXPANDED_ROWS = 5;

const SelectionsGridColumns = ({ eventId, marketId, headers, showSelectionLabels = false }) => {
    let selectionsIds = useSortedSelectionsIds(eventId, marketId);
    const [defaultExpandedCells, setDefaultExpandedCells] = useState([]);
    const [defaultCollapsedCells, setDefaultCollapsedCells] = useState([]);

    useEffect(() => {
        setSelectionRows();
    }, [selectionsIds]);

    const setSelectionRows = () => {
        const numRows = selectionsIds.length;
        const expanded = [];
        const collapsed = [];

        selectionsIds.forEach(({ label, caption = null, ids }, index) => {
            const row = <CellSelectionLine
                key={label}
                ids={ids}
                label={label}
                caption={caption}
                isLastRow={(index < DEFAULT_EXPANDED_ROWS) && (index === numRows - 1)}
                showSelectionLabels={showSelectionLabels}
            />;

            if (index < DEFAULT_EXPANDED_ROWS) {
                expanded.push(row);
            } else {
                collapsed.push(row);
            }
        });

        setDefaultExpandedCells(expanded);
        setDefaultCollapsedCells(collapsed);
    };

    return (
        <>
            <div className="selections-col-grid selections-col-grid__header-section">
            {
                headers.map(header => {
                    return <div
                        className="selections-col-grid__headers"
                        key={header}
                    >{header}</div>;
                })
            }
            </div>
            <div className="selections-col-grid">
                {defaultExpandedCells}
            </div>
            {
                (defaultCollapsedCells.length !== 0)
                ? <SeeMore
                        selections={[
                            <div
                                key={'collapsed-grid'}
                                className="selections-col-grid"
                            >
                                {defaultCollapsedCells}
                            </div>,
                        ]}
                        collapseExtraClass="selections-col-grid__see-more"
                    />
                : null
            }
        </>
    );
};

SelectionsGridColumns.propTypes = {
    eventId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    marketId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    headers: PropTypes.array,
    showSelectionLabels: PropTypes.bool,
};

export default SelectionsGridColumns;
